import styled from 'styled-components';

import {Caption} from '@/componentLibrary/components/typography';
import {ColorFgError, SpacingSmall} from '@/componentLibrary/tokens/variables';

export const ErrorDisplay = styled(Caption)`
    color: ${ColorFgError};
    margin-top: ${SpacingSmall};
`;
